import httpService from './httpService';
import {
    LoginRequest,
    LoginResponse,
    LogoutRequest,
    CustomAxiosRequestConfig,
    APIResponse,
    LoginFailedResponse,
} from '../types';

export async function loginAPI(data: LoginRequest): APIResponse<LoginResponse | LoginFailedResponse> {
    return await httpService.post('/login', data, {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
}

export async function logoutAPI(data: LogoutRequest): Promise<void> {
    await httpService.post('/logout', data, {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
}
